var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSnapshot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_snapshot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .snapshot-class-a {\n        fill: none !important;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M104.445,320a2.859,2.859,0,0,1,2.859,2.858V342.87a2.859,2.859,0,0,1-2.859,2.858H75.859A2.859,2.859,0,0,1,73,342.87V322.858A2.859,2.859,0,0,1,75.859,320Zm-22.869,2.858H75.859V342.87h5.717Zm1.429,0V342.87h21.44V322.858Zm2.859,3.574a.714.714,0,0,1,.715-.714h2.859a.714.714,0,1,1,0,1.428H86.579A.714.714,0,0,1,85.864,326.432Zm9.291.714a6.432,6.432,0,1,1-6.432,6.432A6.432,6.432,0,0,1,95.155,327.146Zm0,1.43a5,5,0,1,0,5,5A5,5,0,0,0,95.155,328.576Z",
    transform: "translate(-68.58 -311.2)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    className: "snapshot-class-a",
    "data-name": "Rectangle 552",
    width: 44,
    height: 44
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSnapshot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_snapshot.2b910e5efdcafffe291344ba5580cdea.svg";